/**
 * Metafans BuddyPress Text Formatter
 * Handles the rich text toolbar and selection tooltips in the activity editor.
 */

class TextFormatter {
    constructor() {
        this.editor = document.querySelector('.advanced-th-bp-activity-form');
        this.buttons = document.querySelectorAll('.text-formatter [data-command]');
        this.tooltip = document.querySelector('.tooltip-formatting');
        this.savedSelection = null;

        if (this.editor && this.buttons.length > 0) {
            this.init();
        }
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        // Save selection on interaction
        ['mouseup', 'keyup', 'focus'].forEach(evt => {
            this.editor.addEventListener(evt, () => this.saveSelection());
        });

        // Hide tooltip when clicking outside
        document.addEventListener('click', (e) => {
            if (this.tooltip && !this.tooltip.contains(e.target) && !this.editor.contains(e.target)) {
                this.tooltip.classList.add('hidden');
                this.tooltip.style.display = 'none'; // Ensure it hides
            }
        });

        // Toolbar Button Clicks
        this.buttons.forEach(btn => {
            // Prevent focus loss
            btn.addEventListener('mousedown', (e) => e.preventDefault());

            btn.addEventListener('click', () => {
                const command = btn.getAttribute('data-command');
                this.restoreSelection();
                document.execCommand(command, false, null);
                this.editor.focus();
                this.updateButtonStates();
            });
        });
    }

    saveSelection() {
        const sel = window.getSelection();

        if (!this.tooltip) return;

        // Check if there is a valid text selection
        if (sel && sel.rangeCount > 0 && !sel.isCollapsed && sel.toString().trim().length > 0) {
            this.savedSelection = sel.getRangeAt(0);
            this.showTooltip(this.savedSelection);
        } else {
            this.tooltip.style.display = 'none';
            this.tooltip.classList.add('hidden');
        }

        this.updateButtonStates();
    }

    restoreSelection() {
        const sel = window.getSelection();
        sel.removeAllRanges();
        if (this.savedSelection) {
            sel.addRange(this.savedSelection);
        }
    }

    updateButtonStates() {
        this.buttons.forEach(btn => {
            const command = btn.getAttribute('data-command');
            try {
                const isActive = document.queryCommandState(command);
                btn.classList.toggle('active', isActive);
            } catch (err) {
                // Ignore unsupported commands
            }
        });
    }

    showTooltip(range) {
        // Insert temporary marker to calculate position
        const tempRange = range.cloneRange();
        const marker = document.createElement('span');
        marker.id = 'selection-marker';
        marker.style.cssText = 'position:absolute; width:1px; height:1px; display:inline-block;';

        tempRange.collapse(true); // Start of selection
        tempRange.insertNode(marker);

        const rect = marker.getBoundingClientRect();

        // Setup tooltip
        this.tooltip.style.display = 'flex';
        this.tooltip.style.visibility = 'hidden';
        this.tooltip.classList.remove('hidden');

        const tooltipWidth = this.tooltip.offsetWidth;
        const tooltipHeight = this.tooltip.offsetHeight;
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const scrollLeft = window.scrollX || document.documentElement.scrollLeft;

        // Calculate Position (Centered above selection)
        let top = scrollTop + rect.top - tooltipHeight - rect.height - 8;
        let left = scrollLeft + rect.left - (tooltipWidth / 2);

        // Fallback if off-screen top
        if (top < 0) {
            top = scrollTop + rect.bottom + 8;
        }

        this.tooltip.style.top = `${top}px`;
        this.tooltip.style.left = `${Math.max(8, left)}px`;
        this.tooltip.style.visibility = 'visible';

        marker.remove();
        // Clean up text node split caused by insertNode
        this.editor.normalize();
    }
}

export function init() {
    return new TextFormatter();
}